var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 374,
    viewBox: "0 0 486 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.24 298.27C485.24 339.885 451.511 373.63 409.883 373.63H0.752991V75.75C0.752991 34.124 34.483 0.379028 76.117 0.379028H485.237L485.236 298.269L485.24 298.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.86 193.54C363.546 193.794 375.298 193.024 386.937 193.94C398.724 196.139 401.565 213.983 391.093 219.827C383.948 223.677 375.46 221.261 367.714 221.94H351.86V193.54ZM393.694 161.395C396.29 170.559 387.456 178.787 378.63 177.525H351.86C352.048 168.883 351.493 159.503 352.132 151.316C362.856 151.618 373.679 150.7 384.341 151.796C388.922 152.947 392.756 156.713 393.694 161.395ZM458.119 25.495C458.617 42.996 458.191 61.422 458.334 79.278C458.301 151.874 458.404 224.468 458.277 297.068C457.807 324.275 433.695 347.916 406.676 348.459C379.631 348.569 352.582 348.476 325.533 348.506V238.756C355.004 238.604 384.49 239.065 413.949 238.526C427.615 237.668 442.584 228.651 443.22 213.612C444.829 198.508 430.589 188.061 417.069 186.411C411.872 186.276 412.024 184.896 417.069 184.294C429.964 181.507 440.09 168.161 436.296 154.795C433.063 140.737 417.525 135.296 404.601 135.323C378.249 135.144 351.892 135.298 325.539 135.246C325.709 114.757 325.184 94.246 325.822 73.772C327.91 47.056 352.629 25.024 379.268 25.502C405.555 25.498 431.838 25.498 458.119 25.497V25.495Z",
    fill: "url(#paint0_linear_1_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.74 76.54C28.413 49.376 52.628 25.929 79.612 25.532C106.557 25.449 133.506 25.52 160.451 25.496C160.377 116.381 160.597 207.276 160.34 298.156C159.302 324.99 135.351 347.99 108.661 348.465C81.665 348.563 54.666 348.479 27.669 348.506V235.056C53.892 241.251 81.391 243.888 108.143 239.779C124.134 237.206 141.63 229.353 147.044 212.763C151.028 198.572 148.785 183.637 149.378 169.072V135.247H103.081C102.873 157.618 103.507 180.028 102.746 202.372C101.498 216.106 87.897 224.832 74.944 224.366C58.88 224.536 27.047 212.724 27.047 212.724C26.967 170.81 27.513 118.319 27.74 76.544V76.54Z",
    fill: "url(#paint1_linear_1_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72 148.89C175.283 149.407 177.23 140.589 176.607 137.244C176.773 116.094 176.26 94.921 176.89 73.786C178.972 46.957 203.881 24.87 230.628 25.498H309.396C309.322 116.383 309.541 207.278 309.285 298.158C308.246 324.992 284.293 347.991 257.602 348.467C230.605 348.569 203.605 348.483 176.606 348.509V224.209C195.045 239.338 220.106 241.693 243.078 241.734C260.396 241.728 277.613 239.058 294.431 235.064V212.292C275.478 221.738 253.198 227.738 232.188 222.311C217.532 218.663 206.893 204.499 207.13 189.374C205.432 173.645 214.652 157.039 230.109 152.363C249.3 146.355 270.216 150.95 288.205 158.761C292.059 160.779 295.971 163.282 294.43 156.84V138.941C264.344 131.783 232.326 129.149 202.1 136.936C193.351 139.404 184.827 143.147 177.72 148.892V148.89Z",
    fill: "url(#paint2_linear_1_15)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_15",
    x1: 324.626,
    y1: 180.094,
    x2: 457.496,
    y2: 180.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_15",
    x1: 24.8439,
    y1: 190.094,
    x2: 158.274,
    y2: 190.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_15",
    x1: 176.411,
    y1: 183.226,
    x2: 309.371,
    y2: 183.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 374,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.e34aa072579377f100904b881339335f.svg";
export { ForwardRef as ReactComponent };